import {Component} from '@angular/core';
import {BaseComponent} from '../base-overlay/base.component';
import {VideoStateEnum} from '../../../../enums/video-state.enum';

@Component({
    selector: 'eocm-default',
    templateUrl: './default-overlay.component.html',
    styleUrls: ['./default-overlay.component.scss', '../../overlay.component.scss']
})
export class DefaultOverlayComponent extends BaseComponent {

    override onClick(event: MouseEvent) {
        if (this.browseService.isMobileDevice() && this.videoState !== VideoStateEnum.Interaction) {
            this.bufferService.$overlayClicked.next(event);
        }

        this.trackEvent();

        const hasNavigation = Boolean(this.overlay.navigateTo);
        if (hasNavigation) {
            this.navigate();
        }
    }
}
